import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const DeleteRole = async (roleID, navigate) => {
  const accesstoken = getToken();
  

  if (accesstoken) {
    try {
        const queryParams = new URLSearchParams({
            roleID 
        }).toString();
      const response = await fetch(`${dev_baseUrl}/Role/delete?${queryParams}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
      } else if(response.ok && !data.isError ){
        return data.result;
      } 
      else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
